import { createSlice } from '@reduxjs/toolkit'
import { requestState } from '../type/type'
import { fetchAllUsers, createUser, setUserPassword } from './userActions'

const initialState = {
  users: [],
  status: requestState.idle,
  error: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllUsers.pending, (state) => {
        state.status = requestState.loading
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.status = requestState.success
        state.users = action.payload
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.status = requestState.failed
        state.error = action.error.message
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.users.push(action.payload)
      })
      .addCase(setUserPassword.fulfilled, (state, action) => {
        // Password updated successfully
      })
  },
})

export const userReducer = userSlice.reducer
